// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__MUZW6","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1oUHh"};